import { useSyncExternalStore } from 'react';
import { onlineManager, useIsMutating } from '@tanstack/react-query';

// True while the device has no connection and a write is queued: react-query pauses
// mutations offline and sends them on reconnect, so the page is not stuck, only waiting.
export function useWaitingForConnection(): boolean {
  const online = useSyncExternalStore(onlineManager.subscribe, () => onlineManager.isOnline());
  const pendingWrites = useIsMutating();
  return !online && pendingWrites > 0;
}
